import { render, staticRenderFns } from "./aggregateList.vue?vue&type=template&id=17fd875d&scoped=true"
import script from "./aggregateList.vue?vue&type=script&lang=js"
export * from "./aggregateList.vue?vue&type=script&lang=js"
import style0 from "./aggregateList.vue?vue&type=style&index=0&id=17fd875d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fd875d",
  null
  
)

export default component.exports